export const commonFn = {
  updateLink: (list, match) => {
    const listTab = [];
    const createObj = list.find((tab) => 'create' === tab.key);

    list?.map((tab) => {
      if (['edit', 'view', 'create'].indexOf(tab.key) > -1) {
        if (tab?.path === match?.path) {
          tab.link = match?.url;
          listTab.push(tab);
        }
      } else {
        listTab.push(tab);
      }
    });

    if (listTab.length === 1) {
      listTab.unshift(createObj);
    }

    return listTab;
  },
};
